// import React from 'react';
import React, { useEffect, useState, useContext } from 'react';
import sanityClient from '../News'; // Ensure this file is properly configured
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../assets/css/Home.css';
import '../assets/css/styles.css';
import logo from '../assets/images/logo.png';
import facebookIcon from '../assets/images/icon_facebook_f3a95533ef.svg';
import twitterIcon from '../assets/images/icon_twitter_5310b73e96.svg';
import linkedinIcon from '../assets/images/icon_linkedin_67007bf547.svg';
import youtubeIcon from '../assets/images/icon_youtube_0137e15908.svg';
import { LanguageContext } from '../contexts/LanguageContext'; // Import the LanguageContext
import axios from 'axios';
import HighlightsCarousel from './HighlightsCarousel';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

function Footer() {
  const [articles, setArticles] = useState([]);
  const history = useHistory(); // Use history for navigation
  const handleContactClick = () => {
    history.push('/contact-us'); // Navigate to the contact page
  };

  useEffect(() => {
    axios.get('http://localhost:1337/api/news-articles?populate=*')
      .then((res) => {
        setArticles(res.data.data);
      })
      .catch((err) => console.error('Error fetching articles:', err));
  }, []);

  const { t } = useContext(LanguageContext); // Access translations

  useEffect(() => {
    // Fetch news data from Sanity
    sanityClient
      .fetch(
        `*[_type == "news"]{
          _id,
          title,
          body,
          publishedAt,
          "imageUrl": mainImage.asset->url
        } | order(publishedAt desc)[0...3]` // Fetch the latest 3 news items
      )
      .then((data) => setNews(data))
      .catch((error) => console.error('Error fetching news:', error));
  }, []);

   // Carousel settings
   const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3, // Number of slides visible at once
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true, // Enable navigation arrows
    responsive: [
      {
        breakpoint: 768, // For tablets and smaller devices
        settings: {
          slidesToShow: 1, // Show 1 slide at a time
        },
      },
      {
        breakpoint: 1024, // For medium screens
        settings: {
          slidesToShow: 2, // Show 2 slides at a time
        },
      },
    ],
  };

const [email, setEmail] = useState('');
const [status, setStatus] = useState(null);

const handleSubscribe = async (e) => {
  e.preventDefault();
  setStatus(null);

  if (!email) {
    setStatus('Please enter a valid email.');
    return;
  }

  try {
    const res = await axios.post('https://3sss.cm/subscribe.php',
      new URLSearchParams({ email }),
      { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
    );

    if (res.data.status === 'success') {
      setStatus(t.subscription_success || 'Thank you for subscribing!');
      setEmail('');
    } else {
      setStatus(t.subscription_error || res.data.message);
    }
  } catch (err) {
    console.error(err);
    setStatus(t.subscription_error || 'An error occurred. Please try again.');
  }
};

  return (
    <footer>
      <div className="contact-row">
        <p>{t.get_in_touch}</p>
        <h2>
            <span className="highlight">{t.connect}</span>{t.chat_with_us}
        </h2>
        <button className="btn" onClick={handleContactClick}>{t.contact_us}</button>
      </div>
      <div className="footer">
        <div className="footer-content">
          <div className="footer-row">
            <div className="newsletter">
              <h4>{t.subscribe_newsletter}</h4>
              <p>{t.newsletter_description}</p>
            </div>
            <div className="newsletter-form">
              <form onSubmit={handleSubscribe}>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t.enter_your_email}
                  required
                />
                <button type="submit">{t.subscribe}</button>
                {status && <p style={{ marginTop: '10px', color: 'white' }}>{status}</p>}
              </form>
            </div>
          </div>
          <div className="separator"></div>
          <div className="footer-row">
            <div className="footer-column">
              <img src={logo} alt="3S Security Logo" style={{ maxWidth: '80px' }} />
              <p>{t.securing_your_world}</p>
              <div className="social-icons">
                <a href="https://www.facebook.com"><img src={facebookIcon} alt="Facebook" /></a>
                <a href="https://www.twitter.com"><img src={twitterIcon} alt="Twitter" /></a>
                <a href="https://www.linkedin.com"><img src={linkedinIcon} alt="LinkedIn" /></a>
                <a href="https://www.youtube.com"><img src={youtubeIcon} alt="YouTube" /></a>
              </div>
            </div>
            <div className="footer-column">
              <h4 className="q-links">{t.quick_links}</h4>
              <div className="quick-links">
                <div>
                  <a href="/">{t.home}</a>
                  <a href="/about-us">{t.about_us}</a>
                </div>
                <div>
                  <a href="/service">{t.service}</a>
                  <a href="/our-csr">{t.our_csr}</a>
                </div>
                <div>
                  <a href="/careers">{t.careers}</a>
                  <a href="/highlights-insights">{t.highlights_insights}</a>
                </div>
              </div>
            </div>
            <div className="footer-column">
              <h4>{t.contact_info}</h4>
              <a href="mailto:contact@3sss">contact@3sss.cm</a>
              <p>+237 670 271 064 / +237 690 020 228 / +237 651 228 282</p>
              <p>Douala, Cameroon</p>
            </div>
          </div>
          <div className="separator-short"></div>
          <div className="footer-row">
            <div className="footer-column">
              <p>© 3S Security 2024.{t.all_rights_reserved}</p>
            </div>
            <div className="footer-column" style={{ textAlign: 'right' }}>
              <p>Built by <a href="">moon solutions</a></p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;